import { css } from '@goodrx/matisse-react';
export const mediaMaxWidth = styles => ({
  theme
}) => {
  return Object.keys(styles).map(breakpoint => css`
      @media (max-width: ${theme.breakpoints[breakpoint]}) {
        ${styles[breakpoint]};
      }
    `);
};